import * as React from 'react';

import styled from '@emotion/styled';

const StyledStep = styled.div`
	img {
		height: 48px;
		width: 48px;
		margin-right: var(--micro);
	}
`;

export interface StepProps {
	src: string;
	alt: string;
}

export const Step = ({src, alt}: StepProps) => (
	<StyledStep>
		<img src={src} alt={alt} />
	</StyledStep>
)
